var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"safe_sub_div"},[_c('div',{staticClass:"bottom_div"},[_c('img',{attrs:{"src":_vm.List.img}})])])}
var staticRenderFns = []

export { render, staticRenderFns }